import React, { useEffect, useMemo } from "react";
import ReactTooltip from "react-tooltip";

import PropTypes from "prop-types";

import Text from "@cayuse/shared-react.components.form.inputs.text";

import styles from "./styles.css";

const ErrorInput = ({ className, renderInput, validate, value, ...rest }) => {
	const errorMessage = useMemo(
		() => validate(value),
		[ validate, value ]
	);

	useEffect(() => {
		ReactTooltip.rebuild();
	}, [ errorMessage ]);

	const classNames = useMemo(
		() => {
			const baseClassName = className || "";
			if (errorMessage) {
				return `${baseClassName} ${styles.error}`;
			}

			return baseClassName;
		},
		[ className, errorMessage ]
	);

	return (
		<div data-tip={errorMessage}>
			{renderInput({ className: classNames, value, ...rest })}
		</div>
	);
};


ErrorInput.defaultProps = {
	renderInput: props =>
		(
			<Text
				{...props}
			/>
		),
	value: null,
};
ErrorInput.propTypes = {
	className: PropTypes.any,
	renderInput: PropTypes.func,
	validate: PropTypes.func.isRequired,
	value: PropTypes.any,
};

export default ErrorInput;
